export const SET_AGENT_DETAILS = 'SET_AGENT_DETAILS'
export const INITIAL_STATE = 'INITIAL_STATE'
export const SET_AGENTS_LIST = 'SET_AGENTS_LIST'

export function setAgentDetails(agentDetails) {
  return {
    type: SET_AGENT_DETAILS,
    payload: agentDetails
  }
}

export function setInitialState() {
  return {
    type: INITIAL_STATE
  }
}

export function setAgentsList(agentsList) {
  return {
    type: SET_AGENTS_LIST,
    payload: agentsList
  }
}
